import React, { useEffect, useState } from 'react'
import './style.scss';
import { setButtonClick, setErrorButton, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { setIsShowButtonNot } from '../../store/buttonNotSlice';
import CustomTitle from '../../components/UI/title/CustomTitle';
import TopGoalContent from './TopGoalContent';
import PageContent from '../../components/PageContent/PageContent';
import useMixpanel from '../../hooks/useMixpanel';


export default function TopGoal() {
    const initialCheckboxState = [
        {
            id: '0',
            checked: false,
            text: "Drive sales, revenue, or conversions",
        },
        {
            id: '1',
            checked: false,
            text: "Be more productive and reduce costs",
        }
    ];

    const [disabled, setDisabled] = useState(true);
    const [checkboxes, setCheckboxes] = useState(initialCheckboxState);
    const [error, setError] = useState(false);
    const [value, setValue] = useState('');

    const dispatch = useDispatch();
    const history = useHistory();
    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const { trackP1Event } = useMixpanel();
    useEffect(() => {
        if (buttonClicked) {
            if (disabled) {
                setError(true);
                dispatch(setErrorButton(true))
                dispatch(setButtonClick(false));
                setTimeout(() => {
                    setError(false);
                    dispatch(setErrorButton(false))
                }, 2000);
                return;
            }
            trackP1Event('onboarding_ad_top_goals', {
                goal_choosen: initialCheckboxState[value].text
            })
            dispatch(setButtonClick(false));
            queryParams.set('top-goal-id', value);
            queryParams.set('top-goal', initialCheckboxState[value].text);
            history.push({
                pathname: value === '0' ? nextPage : 'productivity-goals',
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonClicked, dispatch, disabled]);


    useEffect(() => {
        dispatch(setIsShowButton(true));
        dispatch(setTextButton('Continue'));
        dispatch(setIconButton(''));

        dispatch(setIsShowButtonNot(false));
    }, []);


    return (
        <div className="platfroms page">
            <PageContent>
                <div className="page-content">
                    <CustomTitle
                        style={{ marginBottom: '24rem' }}
                        title={'What’s your goal with AI?'}
                    />
                    <div className="platfroms-wrapper">
                        <TopGoalContent checkboxes={checkboxes} setCheckboxes={setCheckboxes} error={error} setDisabled={setDisabled} setError={setError} setValue={setValue} />
                    </div>
                </div>
            </PageContent>

        </div>
    )
}
